import React, { useEffect } from "react";
import {
  // BrowserRouter as Router,
  // Switch,
  Route,
  // Link,
  Redirect
} from "react-router-dom";
import { useHistory } from "react-router";
import { useAuth } from "./use-auth.js";

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
export function SecureRoute({ children, ...rest }) {
  const history = useHistory();
  const auth = useAuth();

  useEffect(() => {
    // console.info(auth.user);
    if(auth.user && auth.user.pkg_id) return;
    if(auth.user) {
      history.push("/subscribe");
      return;
    }

    window.location.href = "/welcome.html";
  }, [auth, history])
  
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/welcome.html",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}
